import React from 'react';
import './Cali.css'; 

const Villavicencio = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKVV.pdf" target="_blank" rel="noreferrer">Aeropuerto Vanguardia</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 05</th>                      
          </tr>  
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/VVC1K.pdf" target="_blank" rel="noreferrer">VVC1K</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/NIPN2A.pdf" target="_blank" rel="noreferrer">NIPN2A</a></th>
          </tr>
              
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 23</th>                      
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 05</th>                      
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/ANLA5A.pdf" target="_blank" rel="noreferrer">ANLA5A</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 23</th>                      
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/EVRA3F.pdf" target="_blank" rel="noreferrer">EVRA3F</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/EVRA3F.pdf" target="_blank" rel="noreferrer">KOTE2A</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/EVRA3F.pdf" target="_blank" rel="noreferrer">OGNA2A</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/EVRA3F.pdf" target="_blank" rel="noreferrer">OPTU2A</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/EVRA3F.pdf" target="_blank" rel="noreferrer">UBNO2A</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/EVRA3F.pdf" target="_blank" rel="noreferrer">UBRID2B</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/EVRA3F.pdf" target="_blank" rel="noreferrer">OSOV1J</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/EVRA3F.pdf" target="_blank" rel="noreferrer">POVK1B</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/ANLA3C.pdf" target="_blank" rel="noreferrer">ANLA3C</a></th>
          </tr>

         
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 05</th>                      
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/VORA05.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 23</th>                      
          </tr> 
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/VORB23.pdf" target="_blank" rel="noreferrer">VOR B</a></th>
          </tr>
          <tr>
             <th className='Procedimientos'><a href="/regionales/SKVV/RNP23.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Villavicencio;